var $j = require('jquery');
var hideTranscript = require('./brightcove-hide-transcript');
var initializePlaylist = require('./brightcove-playlist.js');
var showCustomErrorOnTimeout = require("./brightcove-show-customError.js");



window.bcPlayerAjaxLoader = function bcPlayerAjaxLoader(renderingUniqueId, reloadOnCookieAccept) {
    // #region pseudo-constants
    this.consentCookieName = 'OptanonConsent';
    this.trackingGroupAcceptedSubstring = ',4:1';
    this.requiredAjaxDataProperties = ['datasourceItemId', 'mediaItemId', 'playerId'];
    this.loadingTag = '<div><!-- Loading... --></div>';
    this.uri = '/api/sitecore/MediaFrameworkAjax/RenderVideoAjax';
    // #endregion pseudo-constants


    // #region settings
    this.renderingUniqueId = renderingUniqueId;
    this.selector = `[data-video-id=${this.renderingUniqueId}]`;
    this.reloadOnCookieAccept = !!reloadOnCookieAccept;
    // #endregion settings


    // #region module state variables
    this.playerLoadData = null;
    this.firstLoadComplete = false;
    this.newReloadInProgress = false;
    // #endregion module state variables

    this.$playerContainer = function () { return $j(this.selector); }

    this.getDecodedConsentCookie = function () {
        return window.decodeURIComponent(
            window.GenericUtilities.getCookieByName(this.consentCookieName)
        );
    }

    this.currentConsentCookieState = this.getDecodedConsentCookie();

    // TODO: move to generic js utility file
    this.xOr = function (expression1, expression2) {
        return !expression1 !== !expression2;
    };

    // TODO: move to generic js utility file
    this.isObject = function isObject(item) {
        return (typeof item === 'object' && !Array.isArray(item) && item !== null);
    }

    this.verifyData = function verifyData() {
        var self = this;
        this.requiredAjaxDataProperties.forEach(function (property) {
            if (self.playerLoadData[property] === undefined) {
                return;
            }
        });
    }

    this.cookieHasChanged = function () {
        var newConsentCookie = this.getDecodedConsentCookie();
        var hasChanged = this.xOr(
            this.trackingCookieIsAccepted(newConsentCookie),
            this.trackingCookieIsAccepted(this.currentConsentCookieState)
        );
        this.currentConsentCookieState = newConsentCookie;
        return hasChanged;
    }

    this.trackingCookieIsAccepted = function (consentCookie) {
        if (!consentCookie) consentCookie = this.getDecodedConsentCookie();
        return consentCookie.indexOf(this.trackingGroupAcceptedSubstring) > -1
    }

    this.shouldReloadIfCookiesAreAccepted = function () { return reloadOnCookieAccept && !this.trackingCookieIsAccepted(); }

    // Cookie polling

    this.cookieWatcherForPlayerSwitch = function cookieWatcherForPlayerSwitch() {

        if (this.newReloadInProgress) {
            // Do not monitor cookie status while load is in progress.
            return;

        } else if (!this.firstLoadComplete) {
            setTimeout(this.cookieWatcherForPlayerSwitch.bind(this), 500);
            return;
        } else {
            if (!this.cookieHasChanged()) {
                setTimeout(this.cookieWatcherForPlayerSwitch.bind(this), 500);
                return;
            } else {
                this.newReloadInProgress = true;
                this.ajaxLoad();
                return;
            }
        }
    }

    this.ajaxLoad = function ajaxLoad(data) {
        var self = this;


        if (this.isObject(data)) {
            this.playerLoadData = data;
        }
        this.verifyData();

        this.$playerContainer().html(this.loadingTag);

        showCustomErrorOnTimeout(this.$playerContainer());

        $j.ajax({
            url: this.uri,
            data: this.playerLoadData,
            type: 'POST',
            cache: false,
            success: function (data, status, jqXhr) {
                if (status !== 'success') {
                    self.$playerContainer().html('');
                    return;
                }

                if (!data.BrightcovePlayerId) {
                    self.$playerContainer().html('');
                    return;
                }

                // TODO: This should be parameterized, but is coming back as "undefined" from the AJAX call.
                data.AccountId = '105925302001';

                var s = document.createElement('script');
                s.src = `//players.brightcove.net/${data.AccountId}/${data.BrightcovePlayerId}_default/index.min.js`;
                document.body.appendChild(s);

                var t = document.createElement('script');
                t.src = `//p3.3playmedia.com/p3sdk.current.js`;
                document.body.appendChild(t);

                function intializePlayers()  {
                    
                    let getContainer = new Promise((resolve, reject) => {
                                waitForContainerElement(resolve);
                            });

                        function waitForContainerElement(resolve) {
                            var $configElement = self.$playerContainer().html(data.AjaxRequestResultHtml);
                            if ($configElement.length === 0) {
                                console.warn("The data HTML did not get placed onto the page");
                            } else {
                                
                                resolve($configElement);
                            }
                        }
                    getContainer.then(function ($container) {
                        setTimeout(function () { initializePlaylist($container)}, 3000);
                    });
                }

                intializePlayers();



            },
            error: function () {
                self.$playerContainer().html('');
            },
            complete: function () {

                // Failsafe error message if the loading tag never gets replaced.
                if (self.$playerContainer().html() === self.loadingTag) {
                    self.$playerContainer().html('');
                }


                var trySetVariables = function () {
                    var videoNode = self.$playerContainer().find('video');

                    if (!window.hasOwnProperty('bc') || videoNode.length === 0) {
                        setTimeout(trySetVariables, 1000);
                        return;
                    }

                    var id = videoNode[0].id;
                    window.bc(id);

                    hideTranscript(self.$playerContainer());

                    // Cookie watcher code.
                    self.newReloadInProgress = false;
                    if (!self.firstLoadComplete) { self.firstLoadComplete = true; }

                    if (self.shouldReloadIfCookiesAreAccepted()) {
                        self.cookieWatcherForPlayerSwitch();
                    }

                    $('.p3sdk-container').each(function (i, item) {
                        var id = $(this).attr('player_id');
                        $(item).find('.mf-player-container .video-js').attr('id', id);
                        $(item).find('.mf-player-container video').attr('id', id + '_html5_api');
                    });

                }

                trySetVariables();

            }
        });
    }
};

